import { Controller } from "stimulus";

// The repo's TypeScript lib typings predate HTMLDialogElement.showModal/close.
type ModalDialog = HTMLElement & { showModal(): void; close(): void };

// Opens and closes a native <dialog> from buttons inside the same element.
export default class extends Controller {
  static targets = ["dialog"];

  declare dialogTarget: ModalDialog;

  open(): void {
    this.dialogTarget.showModal();
  }

  close(): void {
    this.dialogTarget.close();
  }
}
